import { Box, Typography, Container } from '@mui/material';
import React from 'react';

import { useIsFixdDomain } from '@/hooks/useDomainConfig';

const PrivacyHeroSection: React.FC = () => {
  const isFixdDomain = useIsFixdDomain();
  const brandName = isFixdDomain ? 'Fixd' : 'Terrai';

  return (
    <Box
      sx={{
        background:
        'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/assets/images/privacy-hero-bg.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: '#FFFFFF',
        py: { xs: 8, md: 12 },
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        position: 'relative',
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
        <Box
          sx={{
            maxWidth: 700,
            mx: 'auto',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography
            variant="h2"
            component="h1"
            fontFamily="Nohemi, sans-serif"
            fontWeight={600}
            sx={{
              fontSize: { xs: '2.5rem', md: '4rem' },
              letterSpacing: '0.01em',
              lineHeight: 1.2,
              textAlign: 'center',
            }}
          >
          We care about your privacy
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 500,
              opacity: 0.9,
              mb: 2,
              fontSize: { xs: '1rem', md: '1.25rem' },
              textAlign: 'center',
              maxWidth: '800px',
            }}
          >
          Your privacy is important to us at {brandName}. We respect your privacy regarding
          all information collected from across our website.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default PrivacyHeroSection;
